import React, { useState } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { formatUrl } from "../../helpers/parse-url";
import { addTutorialQuestion, loadLessonById } from "../../services/documents/documents.context";
import { QuestionUnit } from "../../components/tutorials/question-unit";
import VideoThumb from "../../components/utilities/video";



export const AddQuestions = () => {

    const { token } = useAuth();

    
    const tutorial = useLocation()?.state?.tutorial;

    const _id  = tutorial?.evaluation._id ? tutorial?.evaluation._id : tutorial?.evaluation;

    const  tuId = tutorial?._id; 

    const [loadedTut, setLoadedTut] = useState();

    const [optionsObj, setOptionsObj] = useState({a: '', b: '', c: '', d: ''})

    const [questionData, setQuestionData] = useState({
        question: '',
        answer: '',
        options: [
            
        ],
        evalId: _id
    });

    const quest = loadedTut?.evaluation?.questions;

    const [pageAlert, setPageAlert] = useState();
    const [loading, setLoading] = useState(false);

    const [optSub, setOptSub] = useState(false);

    const isNull = (v) => v === '' || v === undefined || v === null;

    const { a, b, c, d } = optionsObj; 
    const { answer, question } = questionData;

    const incompleteOption = isNull(a) || isNull(b) || isNull(c) || isNull(d);
    
    const incompleteData = incompleteOption || isNull(answer) || isNull(question) || !optSub ;

    const tutorialFromServer = async (id) => {

        try {
            const data = await loadLessonById(id);
            console.log({data: data})
            setLoadedTut(data);
        } catch (error) {
            console.log({error})
        }
       
    }

    React.useEffect(() => {
        (async() =>{
            await tutorialFromServer(tuId)
        })();
        
    },[tuId]);


    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Add questions to tutorial Tutorial"} />
            {loading && <Loader />}
            {pageAlert &&
                <AppAlert
                    caption={pageAlert?.caption}
                    message={pageAlert?.message}
                    accept={"OK"}
                    acceptAction={() =>setPageAlert()}
                />
            }
            <div className="add-page">
                <div className="add-container">
                    <VideoThumb src={formatUrl(tutorial?.video)} />
                    <div className="add-form-container">
                        <form className="add-form">
                            <div className="n-frm-cont">
                                <span className="n-input-cap">Question:</span>
                                <input 
                                    className="n-frm-inpt"
                                    name="question"
                                    value={questionData?.question}
                                    onChange={(e) => {
                                        setQuestionData((q) => ({...q, question: e.target.value}))
                                    }} 
                                />
                            </div>
                            <div className="opt-caption">options</div>
                            <div className="option-box">
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">A:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={optionsObj?.a}
                                        onChange={(e) => {
                                            setOptionsObj((o) => ({...o, a: e.target.value}))
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">B:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={optionsObj?.b}
                                        onChange={(e) => {
                                            setOptionsObj((o) => ({...o, b: e.target.value}))
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">C:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={optionsObj.c}
                                        onChange={(e) => {
                                            setOptionsObj((o) => ({...o, c: e.target.value}))
                                        }} 
                                    />
                                </div>
                                <div className="n-frm-cont">
                                    <span className="n-input-cap">D:</span>
                                    <input 
                                        className="n-frm-inpt"
                                        name="question"
                                        value={optionsObj.d}
                                        onChange={(e) => {
                                            setOptionsObj((o) => ({...o, d:e.target.value}))
                                        }} 
                                    />
                                </div>
                                <button className={classNames("set-btn",{dis: incompleteOption})}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setQuestionData((q) => ({
                                            ...q,
                                            options: [
                                                optionsObj.a, optionsObj.b,optionsObj.c,optionsObj.d
                                            ]
                                        }));
                                        setOptSub(true);
                                    }}
                                >
                                    Submit answer options
                                </button>
                            </div>
                            <div className="n-frm-cont">
                                <span className="n-input-cap">Answer:</span>
                                <input 
                                    className="n-frm-inpt"
                                    name="question"
                                    value={questionData?.answer}
                                    onChange={(e) => {
                                        setQuestionData((q) => ({...q, answer: e.target.value}))
                                    }} 
                                />
                            </div>
                            <div className="frm-button-box">
                                <button 
                                    className={classNames("frm-button",{dis: incompleteData})}
                                    onClick={
                                        async (e) => {
                                             e.preventDefault();
                                            setLoading(true);
                                            const res = await addTutorialQuestion(token,questionData);
                                            setLoading(false);
                                            setPageAlert({
                                                message: res?.message,
                                                caption: "Success"
                                            })
                                            if (!res?.error) {
                                                window.location.reload();
                                                console.log({_id})
                                            }
                                            console.log(token,questionData)
                                    }}
                                    disabled={incompleteData}
                                >
                                    Add question
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="questions-cont">
                    { quest?.map((question,i) => {
                        return (
                            <QuestionUnit
                                questionData={question}
                                submited={true}
                                indx={i}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}